export function defaultValuesPackages(viewProperty, name) {
  if (typeof viewProperty.metadata.sscc !== 'object') {
    return;
  }

  if (Array.isArray(viewProperty.metadata.sscc)) {
    viewProperty.metadata.sscc = viewProperty.metadata.sscc.map(prop => {
      if (prop.type === 'counter') {
        prop.value = prop.value || `ALBARAN_${name}`;
      }
      return prop;
    });
  } else if (!viewProperty.metadata.sscc.counter) {
    viewProperty.metadata.sscc.counter = `ALBARAN_${name}`;
  }
}
